module.exports = __webpack_public_path__ + "img/wuLong1.5ec0fecd.png";